import React from "react";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { TbInfoHexagon } from "react-icons/tb";
import cn from "../../../lib/cn";
import { connectionTypeIcons } from "../../../resources/js/icons";
import P from "../../../shared/typography/P";

const statusClass =
    "flex items-center py-0.1 px-0.8 text-xs rounded-full gap-0.5";

const CompletedProjectCard = (props) => {
    return (
        <div>
            <div className="pb-1.5 mb-1.5 border-b border-blue-200">
                <div className="flex justify-between gap-1">
                    <div className="flex gap-1 items-center">
                        <img
                            src={connectionTypeIcons[props?.type]}
                            alt={props?.type}
                            className="h-3"
                        />
                        <P className="text-blue font-medium text-sm truncate">
                            {props?.plantName}
                        </P>
                    </div>
                    {props?.delay ? (
                        <div
                            className={cn(
                                statusClass,
                                " bg-orange-50 text-orange border border-orange text-nowrap"
                            )}
                        >
                            <TbInfoHexagon className="text-base" />
                            {props?.delay}
                        </div>
                    ) : (
                        <div
                            className={cn(
                                statusClass,
                                " text-green-200 bg-green-100 border border-green-200"
                            )}
                        >
                            <IoCheckmarkCircleOutline className="text-base" />{" "}
                            No delays
                        </div>
                    )}
                </div>

                <div className="flex items-center justify-between mt-1">
                    <P className="text-xs font-vietnam text-gray-370 capitalize">
                        Current Receipt: ₹{" "}
                        {Number(props?.currentReceipt || 0).toLocaleString()}
                    </P>
                    <P className="text-xs  text-gray-370">
                        Paid: ₹ {Number(props?.paid || 0).toLocaleString()}
                    </P>
                </div>

                <div className="flex items-center justify-between mt-1">
                    <P className="text-xs font-vietnam text-gray-370 capitalize">
                        Total Amount: ₹{" "}
                        {Number(props?.totalAmount || 0).toLocaleString()}
                    </P>
                    <P className="text-xs  text-gray-370">
                        Collection: ₹{" "}
                        {Number(props?.collection || 0).toLocaleString()}
                    </P>
                </div>

                <div className="flex items-center justify-between mt-1">
                    <P
                        onClick={props.onStageClick}
                        className="text-xs text-blue cursor-pointer"
                        role="button"
                    >
                        Project Stage
                    </P>
                    <P
                        onClick={props.onHistoryClick}
                        className="text-xs text-blue cursor-pointer"
                        role="button"
                    >
                        Payment History
                    </P>
                </div>
            </div>
        </div>
    );
};

export default CompletedProjectCard;
